<template>
  <div>
    <v-app-bar fixed elevation="1" color="white">
      <v-toolbar-title> Escolas </v-toolbar-title>
      <v-btn depressed rounded @click="logout()">Sair</v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        filled
        dense
        rounded
        placeholder="Busca"
        hide-details
        clearable
        v-model="search"
        @click:clear="clearSearch"
      ></v-text-field>
      <v-autocomplete
        class="ml-3"
        filled
        dense
        rounded
        placeholder="Filtrar por cidade"
        hide-details
        v-model="city"
        :items="cities"
        item-text="name"
        item-value="id"
        return-object
      ></v-autocomplete>
      <v-spacer></v-spacer>
      <v-btn depressed rounded @click="$router.push('newSchool')"
        >Adicionar escola</v-btn
      >
    </v-app-bar>
    <div class="mt-3 pt-3"></div>
    <v-list three-line class="mt-5 pt-5">
      <template v-for="(item, index) in filteredItems">
        <v-list-item :key="item.title" @click="setSchool(item)">
          <v-list-item-content>
            <v-list-item-title v-html="item.name"></v-list-item-title>
            <v-list-item-subtitle
              >Diretor: {{ item.director }}</v-list-item-subtitle
            >
            <v-list-item-subtitle
              >Rede
              {{
                item.type == 0 ? "Estadual" : "Municipal"
              }}</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider
          class="my-0"
          v-if="index + 1 < filteredItems.length"
          :key="index"
        ></v-divider>
      </template>
    </v-list>
  </div>
</template>

<script>
import { cities } from "@/utils";
export default {
  created() {
    this.schools = this.$store.state.schools;
    this.$store.commit("setEditSchool", {});
  },
  data() {
    return {
      cities,
      city: {
        id: "",
      },
      schools: [],
      search: "",
      selectedSchool: {},
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/AUTH_LOGOUT");
    },
    setSchool(school) {
      this.$store.commit("setEditSchool", school);
      this.$router.push("newSchool");
    },
    clearSearch() {
      this.search = "";
    },
  },
  computed: {
    filteredItems() {
      if (!this.city.id) {
        return this.schools.filter((school) => {
          if (!this.search) return this.schools;
          return school.name.toLowerCase().includes(this.search.toLowerCase());
        });
      } else {
        return this.$store.getters
          .schoolsByCity(this.city.id)
          .filter((school) => {
            if (!this.search) return this.schools;
            return school.name
              .toLowerCase()
              .includes(this.search.toLowerCase());
          });
      }
    },
  },
};
</script>

<style>
</style>